export enum CarouselEffect {
  Scrollx = 'scrollx',
  Fade = 'fade'
}
